// gen
// const baseUrl = "https://mlxna.lizihulian.com/api";
// dev
const baseUrl = "https://malaixna.ubooking.cn/api";
export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js